import { GoodToKnowUI } from "@/components/ProductSideDrawers/GoodToKnow/GoodToKnowUI.tsx";

type GoodToKnowProps = {
  ean?: string;
  cleanBeautyBaseUrl: string;
  isChanel: boolean;
};

export function GoodToKnow({
  ean,
  cleanBeautyBaseUrl,
  isChanel,
}: GoodToKnowProps) {
  if (!ean || isChanel) {
    return null;
  }
  return <GoodToKnowUI cleanBeautyBaseUrl={cleanBeautyBaseUrl} ean={ean} />;
}
